module.exports = __webpack_public_path__ + "static/media/bg.f374a23f.jpg";